import { observer } from 'mobx-react-lite';
import { optionsFull_save, optionsFull_cancel } from './SettingsFormHeader.locstring.json';
import loc from 'owa-localize';
import { saveOptions, discardOptions } from 'owa-options-orchestration';
import { getStore } from 'owa-options-store';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import {
    OptionSubCategory,
    isAnyOptionDirty,
    hideSaveDiscardButtons,
    shouldDisableSaveButton,
} from 'owa-options-core';
import { CSSTransition } from 'react-transition-group';
import { mergeStyles } from '@uifabric/merge-styles';
import { AnimationStyles } from '@uifabric/styling';

import * as React from 'react';

const styles = require('./OptionsFull.scss');

export interface SettingsFormFooterProps {
    selectedSubCategory: OptionSubCategory;
}

export default observer(function SettingsFormFooter({
    selectedSubCategory,
}: SettingsFormFooterProps) {
    const isFormDirty = isAnyOptionDirty(selectedSubCategory);
    const showFooter = isFormDirty && !hideSaveDiscardButtons(selectedSubCategory);
    const store = getStore();
    const isSaveDisabled = store.isSaving || shouldDisableSaveButton(selectedSubCategory);
    return (
        <CSSTransition
            in={showFooter}
            classNames={{
                enter: mergeStyles(AnimationStyles.slideUpIn20),
                exit: mergeStyles(AnimationStyles.slideDownOut20),
            }}
            unmountOnExit={true}
            mountOnEnter={true}
            timeout={367}>
            <div className={styles.settingsFooter}>
                {store.isSaving && <Spinner size={SpinnerSize.large} className={styles.spinner} />}
                <PrimaryButton
                    text={loc(optionsFull_save)}
                    disabled={isSaveDisabled}
                    onClick={saveOptions}
                />
                <DefaultButton
                    text={loc(optionsFull_cancel)}
                    disabled={store.isSaving}
                    onClick={discardOptions}
                />
            </div>
        </CSSTransition>
    );
});
